"use client";

import React, { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { X, Mail } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
const formsData = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/yang_24_form_forest.png",
  alt: "24 Yang Stil",
  title: "24 YANG STIL",
  description: "Die weltweit bekannteste Form und eine klassische Grundlage für Anfänger*innen.",
  modalDescription: "Die 24 Yang Stil- oder \"Peking\"-Form wurde in den 50er Jahren aus dem traditionellen Yang Stil entwickelt. Ursprünglich für die kaiserliche Familie geschaffen, verzichtet dieser auf dynamische Bewegungen und zeichnet sich durch fließende, runde, katzenhafte Bewegungen aus. Die 24 Figuren sind hervorragend geeignet als Grundlagen Training."
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/yang_32_sword_misty_mountains.png",
  alt: "Yang Stil 32 Schwert",
  title: "Yang Stil 32 Schwert",
  description: "Eine Grundlagen-Form für jegliche Schwert-Technik.",
  modalDescription: "Das Tai-Chi-Schwert gilt als die \"Königin der Waffen\". Anhand der 32 Figuren des Yang Stil Schwertes können die grundlegenden Techniken erlernt werden. Anfänger*innen können von Anfang an mit dem Schwert üben - auch wenn man diese komplexe Waffe mit ihren fūnf Angriffsflächen und Körpertechniken das ganze Leben lang trainiert."
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/woman_taichi_long_staff_practice.png",
  alt: "Sieben Sterne Stock",
  title: "Sieben Sterne Stock",
  description: "Kraftvolle Stockform zur Stärkung der inneren Struktur und Vitalität.",
  modalDescription: "Der Sieben-Sterne-Stock ist eine dynamische Form, die Kraft und Geschmeidigkeit vereint. Mit einer Länge von ca. 1,50 m nutzen wir eine traditionelle \"Wanderstock-Länge\". Er schult deine Standfestigkeit, mobilisiert die Schultern und stärkt deine Ganzkörper-Koordination."
}, {
  id: 4,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/double_fan_48_waterfall.png",
  alt: "48 Doppelfächer",
  title: "48 Doppelfächer",
  description: "Elegante Doppelwaffen-Form für Koordination und künstlerischen Ausdruck.",
  modalDescription: "Diese elegante Form besitzt besonders ästhetischen, anmutigen Ausdruck und fördert die geistige Ruhe. Das Training mit dem Doppelfächer ist eine faszinierende Herausforderung für die Koordination beider Gehirnhälften."
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/ten_harmony_lake.png",
  alt: "10 Harmonie Übungen",
  title: "10 Harmonie Übungen",
  description: "Grundlegendes Tai Chi für die tägliche Praxis",
  modalDescription: "Diese Übungsreihe wurde speziell für Menschen entwickelt, die im Alltag in kurzer Zeit und auf begrenztem Raum üben wollen. Sie enthält wesentliche Figuren des Yang-Stils und ist eine besonders kompakte Einsteiger-Form."
}];
export default function OurForms() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const [openId, setOpenId] = useState<number | null>(null);
  const selectedForm = formsData.find(form => form.id === openId);
  return <div className="flex flex-col font-['Montserrat']">
      <section id="unsere-formen" className="bg-background py-20 md:py-32 px-4 md:px-8 overflow-hidden">
        <div className="max-w-[1400px] mx-auto">
          <div ref={headerRef} className={cn("mb-16 text-center transition-all duration-700 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-[#2C5354] tracking-tight uppercase">
              Unsere Formen
            </h2>
          </div>

          <div ref={gridRef} className={cn("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 justify-center transition-all duration-1000 ease-out delay-200", isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
            {formsData.map(form => <div key={form.id} onClick={() => setOpenId(form.id)} className="relative overflow-hidden rounded-xl shadow-sm h-[350px] lg:h-[450px] group cursor-pointer">
                <img src={form.image} alt={form.alt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-[#2C5354]/80 flex flex-col justify-end p-8 text-white transition-all duration-500">
                  <h3 className="text-xl font-medium tracking-wide transition-transform duration-500 group-hover:-translate-y-2 uppercase">
                    {form.title}
                  </h3>
                  <div className="overflow-hidden">
                    <p className="text-sm font-light leading-relaxed opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100 transform translate-y-4 group-hover:translate-y-0">
                      {form.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <Dialog open={openId !== null} onOpenChange={open => !open && setOpenId(null)}>
            <DialogContent className="bg-white max-w-2xl p-0 overflow-hidden border-none rounded-2xl shadow-2xl">
              {selectedForm && <div className="relative p-10 md:p-16 bg-white">
                  <button onClick={() => setOpenId(null)} className="absolute top-6 right-6 p-2 rounded-full hover:bg-muted/50 transition-colors text-[#2C5354]/40 hover:text-[#2C5354] z-10">
                    <X size={24} strokeWidth={1.2} />
                  </button>
                  <DialogHeader className="p-0 text-left">
                    <DialogTitle className="text-2xl md:text-3xl font-light text-[#2C5354] tracking-widest uppercase mb-8">
                      {selectedForm.title}
                    </DialogTitle>
                    <DialogDescription className="text-foreground/80 leading-relaxed font-light text-lg md:text-xl">
                      {selectedForm.modalDescription}
                    </DialogDescription>
                  </DialogHeader>
                </div>}
            </DialogContent>
          </Dialog>
        </div>
      </section>

      <section id="cta-tai-chi" className="py-24 md:py-32 text-center bg-background border-t border-[#2C5354]/10">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-[#2C5354] mb-8 uppercase tracking-tight">
            Bereit für die Kunst der Bewegung?
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-light max-w-2xl mx-auto mb-10">
            Hast du Fragen zu den Kursen oder möchtest du tiefer in die Welt des Tai Chi eintauchen? Ich freue mich auf deine Nachricht.
          </p>
          <Button size="lg" asChild className="rounded-full px-10 py-7 text-lg bg-[#2C5354] hover:bg-[#1a3a3b] transition-all shadow-xl">
            <a href="mailto:post@claudiachrist.de?subject=Anfrage%20Tai%20Chi">
              Schreib mir eine Nachricht
              <Mail className="ml-3 size-5" />
            </a>
          </Button>
        </div>
      </section>
    </div>;
}